var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 24,
    viewBox: "0 0 37 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.14287,
    y: 0.571429,
    width: 34.8571,
    height: 22.8571,
    rx: 1.71429,
    fill: "white",
    stroke: "#E5E5EA",
    strokeWidth: 1.14286
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8674 17.3859H15.4426V6.30737H21.8674V17.3859Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8542 11.8457C15.8542 9.59836 16.9509 7.59649 18.6587 6.30641C17.4098 5.36304 15.8337 4.79998 14.1208 4.79998C10.0656 4.79998 6.77835 7.9544 6.77835 11.8457C6.77835 15.737 10.0656 18.8914 14.1208 18.8914C15.8337 18.8914 17.4098 18.3284 18.6587 17.385C16.9509 16.0949 15.8542 14.093 15.8542 11.8457",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5325 11.8457C30.5325 15.737 27.2453 18.8914 23.1901 18.8914C21.4772 18.8914 19.901 18.3284 18.6517 17.385C20.36 16.0949 21.4566 14.093 21.4566 11.8457C21.4566 9.59836 20.36 7.59649 18.6517 6.30641C19.901 5.36304 21.4772 4.79998 23.1901 4.79998C27.2453 4.79998 30.5325 7.9544 30.5325 11.8457",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.e68401892b047ce86d2d52bf1e70c560.svg";
export { ForwardRef as ReactComponent };